<div class="panneau-accord-prealable__container">
	<div class="container__content">
	    <di-accord-prealable [ordonnance]="ordonnance" [accord]="accord"></di-accord-prealable>
    </div>
</div>
